import { Alert, Checkbox, Stack, Text } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import type { RoleTerms } from "../constants/platformTerms";
import { axioTokens } from "../theme";

interface Props {
  copy: NonNullable<RoleTerms["conflictOfInterest"]>;
  accepted: boolean;
  onAcceptedChange: (value: boolean) => void;
}

export function ConflictOfInterestAck({ copy, accepted, onAcceptedChange }: Props) {
  return (
    <Stack gap="md">
      <Alert
        icon={<IconAlertTriangle size="var(--axio-unit-18)" />}
        color="red"
        variant="light"
        title={copy.title}
        styles={{
          root: {
            border: `${axioTokens.unit[1]}px solid ${axioTokens.dangerAlpha20}`,
            background: axioTokens.dangerAlpha05,
          },
        }}
      >
        <Text size="sm" lh="var(--axio-line-height-airy)">
          {copy.body}
        </Text>
      </Alert>
      <Checkbox
        checked={accepted}
        onChange={(e) => onAcceptedChange(e.currentTarget.checked)}
        color="red"
        size="sm"
        styles={{
          label: { paddingLeft: "var(--axio-unit-8)" },
          input: { transition: "var(--axio-transition-all)" },
        }}
        label={
          <Text size="sm" fw={accepted ? 600 : 500} lh="var(--axio-line-height-relaxed)">
            {copy.checkboxLabel}
          </Text>
        }
      />
    </Stack>
  );
}
